import { styled } from 'stitches.config'

export const AnimationRoot = styled('div', {
  marginLeft: 'auto',
  size: '400px',
})

export const AnimationWrapper = styled('div', {
  size: '400px',

  '@bp2': {
    size: '400px',
  },
})
